import * as React from "react";
import PropTypes from "prop-types";
import {
  Field,
  Input,
  makeResetStyles,
  Option,
  tokens,
  Dropdown,
  Radio,
  RadioGroup,
} from "@fluentui/react-components";
import { getValidDaysTaskType } from "../reminders/reminder-helpers";
import "./general-properties.scss";

const useStackClassName = makeResetStyles({
  display: "flex",
  flexDirection: "column",
  rowGap: tokens.spacingVerticalL,
  textAlign: "left",
});

export const GeneralProperties = ({ taskType, setTaskType }) => {
  return (
    <div className={`${useStackClassName()} task-type-general`}>
      <Field label="Task Type Name" required size="large">
        <Input
          value={taskType?.Type}
          placeholder="Untitled Task Type"
          onChange={(e) => setTaskType({ ...taskType, Type: e.target.value })}
        />
      </Field>

      <Field label="Default Task Duration" size="large" required>
        <div className="defaultDuration">
          {(taskType?.DefaultDurationUnits || taskType?.DefaultDurationUnits === '') && (
            <Input
              className="durationValue"
              value={taskType?.DefaultDurationUnits}
              placeholder="2"
              onChange={(e) => {
                getValidDaysTaskType(
                  e.target.value,
                  taskType?.DefaultDurationInterval,
                  taskType,
                  setTaskType
                );
              }}
            />
          )}
          {taskType.DefaultDurationInterval && (
            <Dropdown
              className="durationType"
              value={taskType?.DefaultDurationInterval?.slice(0, -1) + "(s)"}
              selectedOptions={[taskType?.DefaultDurationInterval]}
              onOptionSelect={(_, data) => {
                getValidDaysTaskType(
                  taskType.Days,
                  data.optionValue,
                  taskType,
                  setTaskType
                );
              }}
            >
              <Option value="Days">Day(s)</Option>
              <Option value="Business Days">Business Day(s)</Option>
              <Option value="Weeks">Week(s)</Option>
              <Option value="Months">Month(s)</Option>
              <Option value="Years">Year(s)</Option>
            </Dropdown>
          )}
        </div>
      </Field>

      <Field label="People With Access" size="large">
        <Input disabled />
      </Field>

      <Field label="Access" size="large">
        <RadioGroup
          layout="horizontal"
          defaultValue={taskType?.IsPublic}
          onChange={(_, data) =>
            setTaskType({ ...taskType, IsPublic: data.value })
          }
        >
          <Radio value={true} label="Public" />
          <Radio value={false} label="Private" />
        </RadioGroup>
      </Field>
    </div>
  );
};

GeneralProperties.propTypes = {
  taskType: PropTypes.shape({
    Type: PropTypes.string,
    DefaultDurationUnits: PropTypes.string,
    DefaultDurationInterval: PropTypes.string,
    Days: PropTypes.number,
    IsPublic: PropTypes.bool,
  }),
  setTaskType: PropTypes.func.isRequired,
};
